import React, { useState } from "react";
import { FaShieldAlt, FaExchangeAlt, FaUserShield, FaLock, FaMinus, FaPlus, FaChartLine, FaDatabase, FaRobot, FaUserCheck, FaFileAlt, FaFileContract, FaMicroscope, FaCoins, FaCubes, FaCodeBranch, FaFileSignature, FaIdCard, FaBoxOpen } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Footer from "../../../Component/Fooder";
import { motion } from 'framer-motion';
import Healthcare from "../../../assests/service/Healthcare.jpg";

const BlockchainPoweredHealthcareSecurity = () => {
    const navigate = useNavigate();
    const [openIndex, setOpenIndex] = useState(0);

    return (
        <>
            <div className="w-full bg-gray-50">
                {/* Hero Section */}
                <div
                    className="relative w-full h-[500px] bg-cover bg-center flex flex-col items-center justify-center text-white text-center px-4 mt-2"
                    style={{ backgroundImage: `url(${Healthcare})` }}
                >
                    <div className="absolute inset-0 bg-[rgba(8,3,3,0.7)]  backdrop-blur-none"></div>
                    <motion.div
                        className="relative z-10"
                        initial={{ opacity: 0, x: -100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <h1 className="text-[30px] font-extrabold">Blockchain-Powered-Healthcare-Security</h1>
                        <p className="text-lg mt-4 text-white max-w-3xl">
                            At HIKEHEALTH Gs, We use blockchain technology to ensure top-notch security, transparency, and integrity in healthcare data management. Our solutions protect electronic health records (EHRs), improve data sharing, enhance patient privacy, and prevent fraud—while staying fully compliant with HIPAA, GDPR, and other global healthcare regulations.
                        </p>
                        <button
                            className="mt-3 px-6 py-3 bg-white text-blue-700 font-semibold rounded-lg hover:bg-gray-200 transition"
                            onClick={() => navigate("/Contact")}
                        >
                            LET’S DISCUSS YOUR NEEDS
                        </button>
                    </motion.div>
                </div>

                <div className="bg-white max-w-full mx-auto py-16 px-6">                {/* How We Can Help Section */}
                    <section className="w-full mx-auto  px-2">
                        <h2 className="text-[30px] font-bold text-center flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">How We Can Help</h2>
                        <p className="text-gray-800 text-center text-sm mt-2">
                            Exchanging healthcare data is critical, but it can be complex. We simplify the process, ensuring smooth integration.
                        </p>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto px-4 mt-4">
                            {helpFeatures.map((feature, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                    transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <feature.icon className="text-[#2a627a] text-4xl mx-auto mb-4" />
                                    <h3 className="text-lg text-[#2a627a] font-bold">{feature.title}</h3>
                                    <p className="text-gray-800 text-sm mt-2">{feature.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>
                    {/* Key Interoperability Services */}
                    <section className=" py-12">
                        <div className="w-full mx-auto  ">
                            <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">Key Services</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4 max-w-5xl mx-auto px-4">
                                {services.map((service, index) => (
                                    <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                        initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                        whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                        transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                        viewport={{ once: false, amount: 0.3 }}>
                                        <h3 className="text-lg font-bold text-[#2a627a]">{service.title}</h3>
                                        <p className="text-gray-800 text-sm mt-2">{service.description}</p>
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    </section>
                    {/* Why Choose Us */}
                    <section className="w-full mx-auto ">
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">Why Choose Us?</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4 max-w-5xl mx-auto px-4">
                            {whyChooseUs.map((item, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-6 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                    whileInView={{ opacity: 1, x: 0 }} // Move to center
                                    transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <h3 className="text-lg font-bold text-[#2a627a]">{item.title}</h3>
                                    <p className="text-gray-800  text-sm mt-2">{item.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>
                    {/* Services Section */}
                    <section className="mt-12 w-full  mx-auto">
                        {/* Heading */}
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                            Discover Our Services
                        </h2>

                        {/* Service List */}
                        <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                            {List.map((service, index) => (
                                <div key={index} className="border-b border-gray-800">
                                    {/* Service Title */}
                                    <button
                                        className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                        onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                    >
                                        {service.title}
                                        {openIndex === index ? (
                                            <FaMinus className="text-red-500" />
                                        ) : (
                                            <FaPlus className="text-gray-600" />
                                        )}
                                    </button>

                                    {/* Service Description (Expandable with Animation) */}
                                    <motion.div
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                        transition={{ duration: 0.3, ease: "easeInOut" }}
                                        className="overflow-hidden"
                                    >
                                        <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                    </motion.div>
                                </div>
                            ))}
                        </div>
                    </section>



                </div>
                {/* Contact Section */}
                <div className="w-full bg-[#2a627a] text-white py-12 text-center">
                    <h2 className="text-2xl font-bold">Ready to Transform Healthcare?</h2>
                    <p className="mt-2">Let’s collaborate to build seamless and secure healthcare solutions.</p>
                    <button
                        className="mt-4 px-6 py-3 bg-white text-[#2a627a] font-semibold rounded-lg hover:bg-gray-400 transition"
                        onClick={() => navigate("/Contact")}
                    >
                        Book Your Free Consultation
                    </button>
                </div>
            </div>
            <Footer />
        </>
    );
};

// Data for different sections
const helpFeatures = [
    {
        title: "Secure EHR Management",
        description: "Utilize blockchain to protect electronic health records with tamper-proof encryption.",
        icon: FaLock
    },
    {
        title: "Transparent Data Sharing",
        description: "Enable seamless and secure data exchange between healthcare providers and patients.",
        icon: FaExchangeAlt
    },
    {
        title: "Enhanced Patient Privacy",
        description: "Empower patients with control over their medical data while ensuring compliance with global regulations.",
        icon: FaUserShield
    },
    {
        title: "Fraud Prevention",
        description: "Detect and prevent unauthorized access, insurance fraud, and data breaches using blockchain technology.",
        icon: FaShieldAlt
    },
    {
        title: "Regulatory Compliance",
        description: "Ensure adherence to HIPAA, GDPR, and other healthcare data security standards.",
        icon: FaFileContract
    }
];



const services = [
    {
        title: "Secure EHR Management",
        description: "Store and manage health records on a tamper-proof blockchain ledger.",
        icon: FaLock
    },
    {
        title: "Decentralized Identity Verification",
        description: "Enable patients and providers to access records securely using blockchain authentication.",
        icon: FaUserCheck
    },
    {
        title: "Immutable Audit Trails",
        description: "Maintain a transparent and verifiable record of all data transactions.",
        icon: FaFileAlt
    },
    {
        title: "Smart Contracts for Healthcare Operations",
        description: "Automate billing, insurance claims, and provider agreements with self-executing contracts.",
        icon: FaRobot
    },
    {
        title: "Interoperable Data Exchange",
        description: "Facilitate secure and seamless data sharing across hospitals, labs, and insurers.",
        icon: FaExchangeAlt
    },
    {
        title: "Medical Supply Chain Security",
        description: "Ensure authenticity and traceability of pharmaceuticals and medical devices.",
        icon: FaCubes
    },
    {
        title: "Fraud Prevention & Compliance",
        description: "Protect against data breaches, identity theft, and insurance fraud.",
        icon: FaShieldAlt
    },
    {
        title: "Patient Consent Management",
        description: "Empower patients with granular control over their health data access.",
        icon: FaUserShield
    },
    {
        title: "Tokenization & Rewards",
        description: "Implement blockchain-based incentives for preventive care and healthy behaviors.",
        icon: FaCoins
    }
];

const whyChooseUs = [
    {
        title: "End-to-End Data Encryption",
        description: "We utilize advanced cryptographic techniques to secure sensitive health data.",
        icon: FaLock
    },
    {
        title: "Regulatory Compliance",
        description: "Our solutions are aligned with HIPAA, FHIR, HL7, and GDPR standards.",
        icon: FaFileContract
    },
    {
        title: "Decentralized & Tamper-Proof",
        description: "Protect against data manipulation, cyber threats, and unauthorized access.",
        icon: FaShieldAlt
    },
    {
        title: "Seamless EHR & API Integration",
        description: "Enable blockchain-powered security for existing healthcare systems.",
        icon: FaCodeBranch
    },
    {
        title: "Scalable & Cost-Effective",
        description: "Reduce operational costs while enhancing security and efficiency.",
        icon: FaChartLine
    }
];


const List = [
    {
        title: "Blockchain-Based EHR Solutions",
        description: "Secure patient records with decentralized storage.",
        icon: FaDatabase
    },
    {
        title: "Smart Contract Development",
        description: "Automate insurance claims, billing, and provider agreements.",
        icon: FaFileSignature
    },
    {
        title: "Identity & Access Management",
        description: "Enable self-sovereign identity (SSI) for patients and providers.",
        icon: FaIdCard
    },
    {
        title: "Healthcare Supply Chain Security",
        description: "Ensure the authenticity of pharmaceuticals and medical equipment.",
        icon: FaBoxOpen
    },
    {
        title: "Clinical Trial Data Integrity",
        description: "Protect research data from tampering and unauthorized access.",
        icon: FaMicroscope
    }
];



export default BlockchainPoweredHealthcareSecurity;
